<template>
  <div class="edit-check-list pad">

    <check-list-form v-if="checkList" :check-list="checkList" @submitted="back" />

    <loading v-if="checkList === null" />

  </div>
</template>

<script>
import CheckListForm from '@/components/CheckListForm'
export default {
  name: 'EditCheckList',
  components: {
    CheckListForm
  },
  data () {
    return {
      checkListId: null,
      checkList: null
    }
  },
  watch: {
    checkListId () {
      this.$firestore.collection('checkLists')
        .doc(this.checkListId)
        .get()
        .then(doc => {
          this.checkList = this.$utils.docToObj(doc)
        })
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.checkListId = to.params.id
    next()
  },
  created () {
    this.checkListId = this.$route.params.id
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>

</style>
